// src/components/common/MetricSelector.js
import React from 'react';

const MetricSelector = ({ 
  displayedMetrics, 
  handleMetricChange,
  availableMetrics,
  sensorType 
}) => {
  // Determina quali metriche mostrare in base al tipo di sensore
  const getFilteredMetrics = () => {
    if (sensorType === 'level') {
      return availableMetrics.filter(metric => metric.id === 'livello');
    } else if (sensorType === 'weather') {
      return availableMetrics;
    } else {
      return availableMetrics.filter(metric => 
        ['temperatura', 'umidita', 'dewPoint'].includes(metric.id)
      );
    }
  };

  const filteredMetrics = getFilteredMetrics();

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button collapsed py-2" type="button" data-bs-toggle="collapse" data-bs-target="#metricsCollapse">
          Metriche da visualizzare
        </button>
      </h2>
      <div id="metricsCollapse" className="accordion-collapse collapse" data-bs-parent="#settingsAccordion">
        <div className="accordion-body py-2">
          <div className="d-flex flex-wrap gap-1 mb-2">
            {filteredMetrics.map(metric => (
              <button
                key={metric.id}
                onClick={() => handleMetricChange(metric.id)}
                className={`btn btn-sm rounded-pill ${
                  displayedMetrics.includes(metric.id)
                    ? 'btn-primary'
                    : 'btn-outline-secondary'
                }`}
                title={`${displayedMetrics.includes(metric.id) ? 'Nascondi' : 'Mostra'} ${metric.label.toLowerCase()}`}
              >
                <i className={`bi ${displayedMetrics.includes(metric.id) ? 'bi-eye' : 'bi-eye-slash'} me-1`}></i>
                {metric.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricSelector;